import { render, staticRenderFns } from "./TAskSeoEn.vue?vue&type=template&id=12825160&"
import script from "./TAskSeoEn.vue?vue&type=script&lang=js&"
export * from "./TAskSeoEn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports